module.exports = __webpack_public_path__ + "img/trend-up.041f1c07.svg";